import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useJobs = () => {
  const fetchWithAuth = useFetchWithAuth()
  const getJobs: QueryFunction<string[]> = async () => {
    const response = await fetchWithAuth(`${URL}/profile/jobs`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
    return response
  }

  return useQuery({
    queryKey: ['jobs'] as const,
    queryFn: getJobs,
    retry: false,
    staleTime: 5 * 60 * 1000,
  })
}
